/**
 * Truth or dare cards — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_tabletop_iii`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const truthOrDareCardsPack: ToilePack = {
    slug: 'truth-or-dare-cards',
    category: 'tabletop',
    name: 'Truth or dare cards',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'truth', label: 'Truth cards', subject: 'a printable sheet of eight cards in a 2 by 4 grid with dashed cut lines, each headed "Truth", reading "What is your most embarrassing moment?", "Who was your first crush?" and six more'},
        {key: 'dare', label: 'Dare cards', subject: 'a printable sheet of eight cards in a 2 by 4 grid with dashed cut lines, each headed "Dare", reading "Sing the chorus of a song", "Do ten jumping jacks" and six more'},
        {key: 'blank', label: 'Blank cards', subject: 'a printable sheet of eight blank cards in a 2 by 4 grid with dashed cut lines, four headed "Truth" and four headed "Dare", each with empty ruled lines'},
    ],
    styles: [
        {key: 'neon', label: 'Neon sleepover', style: 'a bold sleepover look with neon-bright borders and rounded lettering', palette: 'hot pink and electric blue on black', framing: 'cards evenly spaced on the page with a wide margin'},
        {key: 'pastel', label: 'Pastel party', style: 'a soft pastel party printable with scalloped card borders and small stars', palette: 'pale pink, lavender and mint on white', framing: 'cards evenly spaced on the page with a wide margin'},
        {key: 'duo', label: 'Two-color', style: 'clean two-color cards, one ink for truth and another for dare, thin borders', palette: 'blue for truth cards and red for dare cards on white', framing: 'cards evenly spaced on the page with a wide margin'},
    ],
    directions: ['for teens', 'for adults', 'family friendly'],
    directionHint: 'try: for teens',
    seo: {
        title: 'Truth or dare cards: truth, dare, blank set',
        metaDescription: 'Printable truth or dare cards in three styles: a sheet of truth cards, a sheet of dare cards and a blank set to write your own.',
        h1: 'Truth or dare cards: truth cards, dare cards, blank cards',
        tagline: 'Nine sheets: truth cards, dare cards and blank cards in both colours, in three styles.',
        intro: 'Friends at a sleepover or a party print a sheet and cut the cards for truth or dare. This pack shows a sheet of truth cards, a sheet of dare cards, and blank cards, four headed Truth and four headed Dare. Each comes as a neon sleepover look, a pastel party style or a two-colour set. Type a tone, such as for teens or family friendly, and the cards keep their two colours.',
        useCases: [
            'a sleepover game',
            'a party game with a mix of guests',
            'a family game with cards of its own',
            'a blank set for questions you write',
        ],
        faq: [
            {q: 'What do the nine pictures show?', a: 'Three readings in three styles: a sheet of truth cards, a sheet of dare cards, and a sheet of blank cards in both colours.'},
            {q: 'How do I tell the truth cards from the dare cards?', a: 'Truth cards are headed Truth and dare cards are headed Dare; in the two-colour style, truth is blue and dare is red.'},
            {q: 'Can I write my own questions?', a: 'Yes. The blank sheet has four cards headed Truth and four headed Dare, each with empty ruled lines.'},
        ],
    },
}
